import type { AppConfig } from './lib/types';

export const APP_CONFIG_DEFAULTS: AppConfig = {
  companyName: '季灿人工智能实验室',
  pageTitle: '季灿心镜',
  pageDescription: '倾听心声 映照自我',

  supportsChatInput: true,
  supportsVideoInput: true,
  supportsScreenShare: true,
  isPreConnectBufferEnabled: true,

  logo: '/jican-icon.jpg',
  accent: '#002cf2',
  logoDark: '/lk-logo-dark.svg',
  accentDark: '#1fd5f9',
  startButtonText: '唤醒心镜',

  // Empty agent name means the first available agent will be dispatched
  // This matches the empty agent_name in the backend worker registration
  agentName: '',
};
